export default __webpack_public_path__ + "static/media/elumntloadingicon.f4d5f228.gif";